export class CadastroHistoricoDto { }
